// src/components/Cards.js

import React from "react";
import { useTranslation } from 'react-i18next';

const Cards = () => {
  const { t } = useTranslation();

  return (
    <div className="cards-section padding-left padding-right">
      {/* Title */}
      <div className="text-center mb-5 pb-5">
        <h2>{t('whyProtectTitle')}</h2>
      </div>

      {/* Cards Container */}
      <div className="container">
        <div className="row">
          {/* First Card */}
          <div className="col-md-6 mb-4">
            <div className="card-1 d-flex align-items-center h-100">
              <div className="me-4">
                <span className="card-title">78</span><span className="card-subtitle">%</span>
              </div>
              <div className="xl">
                {t('moreCyberAttacks')}
              </div>
            </div>
          </div>
          {/* Second Card */}
          <div className="col-md-6 mb-4">
            <div className="card-1 d-flex align-items-center h-100">
              <div className="me-4">
                <span className="card-title">4.5</span><span className="card-subtitle">M</span>
              </div>
              <div className="xl">
                {t('averageCost')}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {/* Third Card */}
          <div className="col-md-6 mb-4">
            <div className="card-2 h-100">
              <span className="xl">
                {t('expectedTrendPart1')} <strong>{t('expectedTrendYear')}</strong> {t('expectedTrendPart2')}
              </span>
            </div>
          </div>
          {/* Fourth Card */}
          <div className="col-md-6 mb-4">
            <div className="card-2 h-100">
              <span className="xl">
                {t('preventDamagePart1')} <span className="color-safe-software"><strong>{t('preventDamageEmphasis')}</strong></span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cards;
